<template>
    <div>
        <section class="site-section" id="section-projects">
            <div class="container pt-5">
                <div class="col-md-12 pb-2">
                    <div class="section-heading text-center">
                        <h2 class="strong">Personal Projects</h2>
                    </div>
                </div>
                <div class="row justify-content-center pt-2">
                    <div class="col-sm-6 col-lg-4">
                        <div class="blog-entry">
                            <img :src="require('../assets/images/proj1.png')" alt="Image placeholder" class="img-fluid">
                            <div class="blog-entry-text">
                                <h3 class="proj-head"><a>All About COVID-19</a></h3>
                                <br>
                                <p class="mb-4 proj-desc">Developed an authentic real-time website using <b>VueJS</b> and <b>RESTful APIs</b> by extracting data from verified sources (WHO, Johns Hopkin
                                    University, Mohfw).</p>
        
                                <div class="meta pt-2">
                                    <center><a href="https://drive.google.com/drive/folders/1pM76gwLIdbfg1BEifXI2aKD3WsvSiyAR?usp=sharing" target="_blank"><v-btn :color="yellow">Project</v-btn></a>
                                        <a href="https://github.com/SohamDave08/AllAboutCovid19" target="_blank"><v-btn :color="yellow">Repository</v-btn></a></center>
                                </div>
                            </div>
                        </div>
                    </div>
        
                    <div class="col-sm-6 col-lg-4 mb-4">
                        <div class="blog-entry">
                            <img :src="require('../assets/images/proj4.jpg')" alt="Image placeholder" class="img-fluid">
                            <div class="blog-entry-text">
                                <h3 class="proj-head"><a>Women Safety App (Codeshastra)</a></h3>
                                <br>
                                <p class="mb-4 proj-desc">A cross-platform app for ensuring women safety with various SOS features using Native app development and Web Development.</p>
                                <div class="meta pt-2">
                                    <center><a href="https://docs.google.com/document/d/1scpvmrJEQXtduqKucMgnHiyFWl__q-btUGXQ2QKzLUI/edit?usp=sharing" target="_blank"><v-btn :color="yellow">Project</v-btn></a></center>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 col-lg-4 mb-4">
                        <div class="blog-entry">
                            <img :src="require('../assets/images/proj2.png')" alt="Image placeholder" class="img-fluid">
                            <div class="blog-entry-text">
                                <h3 class="proj-head"><a>Virtual Labs</a></h3>
                                <br>
                                <p class="mb-4 proj-desc">Developed a virtual simulator to understand experiments visually by using ReactJS as the web framework and Flare-JS for the
                                    animations.</p>
        
                                <div class="meta pt-2">
                                    <center><a href="http://cdac.olabs.edu.in/?sub=74&brch=31&sim=249&cnt=4" target="_blank"><v-btn :color="yellow">Project</v-btn></a>
                                    <a href="https://github.com/mehtaAnsh/VirtualLabs-React" target="_blank"><v-btn :color="yellow">Repository</v-btn></a></center>
                                </div>
                            </div>
                        </div>
                    </div>
        
                    <div class="col-sm-6 col-lg-4 mb-4">
                        <div class="blog-entry">
                            <img :src="require('../assets/images/proj3.png')" alt="Image placeholder" class="img-fluid">
                            <div class="blog-entry-text">
                                <h3 class="proj-head"><a>CamRadar</a></h3>
                                <br>
                                <p class="mb-4 proj-desc">An OpenCV based Machine Learning project. Developed a plugin used to provide an interface for security agencies to recognize criminals from CCTVs using MySQL as the database.</p>
        
                                <div class="meta pt-2">
                                    <center><a href="https://github.com/DaveSoham08/CamRadar" target="_blank"><v-btn :color="yellow">Repository</v-btn></a></center>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-lg-4 mb-4">
                        <div class="blog-entry">
                            <img :src="require('../assets/images/proj5.png')" alt="Image placeholder" class="img-fluid">
                            <div class="blog-entry-text">
                                <h3 class="proj-head"><a>Automated Hospital Management</a></h3>
                                <br>
                                <p class="mb-4 proj-desc">A cross-platform mobile application for seamless operation of hospital management.</p>
                                <div class="meta pt-2">
                                    <center><a href="https://youtu.be/YVA4nBIPkeM" target="_blank"><v-btn :color="yellow">Project</v-btn></a>
                                    <a href="https://github.com/Jash271/SecureHealth" target="_blank"><v-btn :color="yellow">Repository</v-btn></a></center>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-lg-4 mb-4">
                        <div class="blog-entry">
                            <img :src="require('../assets/images/proj6.png')" alt="Image placeholder" class="img-fluid">
                            <div class="blog-entry-text">
                                <h3 class="proj-head"><a>Research[et al.]</a></h3>
                                <br>
                                <p class="mb-4 proj-desc">Developed interractive & responsive website for a Start Up aiming to create a platform for engineering students to implement research-oriented projects & write research papers, while acquiring all the necessary skills relevant to the industry.</p>
                                <div class="meta pt-2">
                                    <center><a href="https://research-etal.com/" target="_blank"><v-btn :color="yellow">Website</v-btn></a></center>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-lg-4 mb-4">
                        <div class="blog-entry">
                            <img :src="require('../assets/images/proj7.png')" alt="Image placeholder" class="img-fluid">
                            <div class="blog-entry-text">
                                <h3 class="proj-head"><a>Course It</a></h3>
                                <br>
                                <p class="mb-4 proj-desc">A full-fledged online learning platform contains numerous features aiming to improve the e-learning system, right from analytics to achieving abstraction and various customization for students/professors.
                                We developed a website as well as a cross-platform mobile application.</p>
                                <div class="meta pt-2">
                                    <center><a href="https://youtu.be/DS0so4L6310" target="_blank"><v-btn :color="yellow">Project</v-btn></a>
                                    <a href="https://github.com/heth0218/T014_Masterbridge" target="_blank"><v-btn :color="yellow">Repository</v-btn></a></center>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        name: "projects",
        data: () => ({
            yellow: '#FFB20A'
        })
    }
</script>

<style scoped>
    .proj-desc{
		color: rgba(255, 255, 255, 0.9) !important;
	}
	.proj-head{
		font-size: 22px !important;
		color: #fff !important;
		line-height: 1.5 !important;
		font-weight: 400 !important;
	}
</style>